import React, { createContext, useContext, useState, useEffect } from 'react';

const DateFormatContext = createContext();

export const DATE_FORMATS = {
  'MM/DD/YYYY': {
    label: 'MM/DD/YYYY (US)',
    format: 'MM/DD/YYYY',
    example: '12/31/2025'
  },
  'DD/MM/YYYY': {
    label: 'DD/MM/YYYY (EU)',
    format: 'DD/MM/YYYY',
    example: '31/12/2025'
  },
  'YYYY-MM-DD': {
    label: 'YYYY-MM-DD (ISO)',
    format: 'YYYY-MM-DD',
    example: '2025-12-31'
  },
  'DD.MM.YYYY': {
    label: 'DD.MM.YYYY',
    format: 'DD.MM.YYYY',
    example: '31.12.2025'
  }
};

export const DateFormatProvider = ({ children, user }) => {
  const [dateFormat, setDateFormat] = useState(() => {
    return localStorage.getItem('dateFormat') || 'MM/DD/YYYY';
  });

  // Sync with user's database preference when user data is available
  useEffect(() => {
    if (user?.date_format) {
      setDateFormat(user.date_format);
    }
  }, [user]);

  useEffect(() => {
    localStorage.setItem('dateFormat', dateFormat);
  }, [dateFormat]);

  const formatDate = (date, includeTime = false) => {
    if (!date) return '';
    
    const d = typeof date === 'string' ? new Date(date) : date;
    if (isNaN(d.getTime())) return '';

    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();
    
    let formattedDate = '';
    
    switch (dateFormat) {
      case 'MM/DD/YYYY':
        formattedDate = `${month}/${day}/${year}`;
        break;
      case 'DD/MM/YYYY':
        formattedDate = `${day}/${month}/${year}`;
        break;
      case 'YYYY-MM-DD':
        formattedDate = `${year}-${month}-${day}`;
        break;
      case 'DD.MM.YYYY':
        formattedDate = `${day}.${month}.${year}`;
        break;
      default:
        formattedDate = `${month}/${day}/${year}`;
    }

    if (includeTime) {
      const hours = String(d.getHours()).padStart(2, '0');
      const minutes = String(d.getMinutes()).padStart(2, '0');
      formattedDate += ` ${hours}:${minutes}`;
    }

    return formattedDate;
  };

  return (
    <DateFormatContext.Provider value={{ dateFormat, setDateFormat, formatDate, DATE_FORMATS }}>
      {children}
    </DateFormatContext.Provider>
  );
};

export const useDateFormat = () => {
  const context = useContext(DateFormatContext);
  if (!context) {
    throw new Error('useDateFormat must be used within DateFormatProvider');
  }
  return context;
};
